<div class="boleto-container">
  <div class="boleto-content">
    <a class="btn-boleto" [href]="getBoletoDetails().pdf" target="_blank" rel="noopener noreferrer"
      [class.disabled]="!getBoletoDetails().pdf" [attr.aria-disabled]="!getBoletoDetails().pdf ? true : null"
      tabindex="{{ getBoletoDetails().pdf ? 0 : -1 }}">
      Visualizar Boleto
    </a>
  </div>
</div>
